/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordSetAttestationData } from './PasswordSetAttestationData';
import {
    PasswordSetAttestationDataFromJSON,
    PasswordSetAttestationDataFromJSONTyped,
    PasswordSetAttestationDataToJSON,
} from './PasswordSetAttestationData';

/**
 * 
 * @export
 * @interface PasswordSetAttestationAllOf
 */
export interface PasswordSetAttestationAllOf {
    /**
     * 
     * @type {PasswordSetAttestationData}
     * @memberof PasswordSetAttestationAllOf
     */
    data?: PasswordSetAttestationData;
}

/**
 * Check if a given object implements the PasswordSetAttestationAllOf interface.
 */
export function instanceOfPasswordSetAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PasswordSetAttestationAllOfFromJSON(json: any): PasswordSetAttestationAllOf {
    return PasswordSetAttestationAllOfFromJSONTyped(json, false);
}

export function PasswordSetAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PasswordSetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordSetAttestationAllOfToJSON(value?: PasswordSetAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PasswordSetAttestationDataToJSON(value.data),
    };
}

